import { v4 as uuidv4 } from 'uuid';
import { COMMON } from '../constants';

let cachedIp: string | null = null;

// gọi ipify 1 lần
async function fetchClientIp() {
  if (cachedIp) return cachedIp;

  try {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    cachedIp = data.ip;
  } catch (err) {
    console.error('Failed to fetch client IP:', err);
    cachedIp = '127.0.0.1';
  }

  return cachedIp;
}

async function getClientParams() {
  const ip = await fetchClientIp();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // timezone client

  return {
    'X-Request-ID': uuidv4(),
    'X-Client-IP': ip,
    'X-Client-Time': new Date().toISOString(),
    'X-Client-Timezone': timeZone || 'Asia/Ho_Chi_Minh',
    'X-Application-Version': COMMON.APP_VERSION,
  };
}
export { getClientParams };
